import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import { useDispatch } from 'react-redux';
import { showSnackbar } from '../api/snackbarSlice';
import { useTranslatedMessages } from '../hooks/useTranslatedMessages';

export default function CopyTextComponent({ copyText }) {
  const dispatch = useDispatch();
  const { common } = useTranslatedMessages();
  const copy_text_component = common.copy_text_component ?? {};

  const handleCopy = () => {
    navigator.clipboard
      .writeText(copyText)
      .then(() => {
        dispatch(showSnackbar({ message: copy_text_component.success_message, severity: 'success' }));
      })
      .catch((err) => {
        dispatch(showSnackbar({ message: copy_text_component.error_message, severity: 'error' }));
      });
  };

  return (
    <Box display="flex" alignItems="center" gap={1}>
      <Typography fontWeight="bold" color="text.secondary">
        {copyText}
      </Typography>
      <Tooltip title={copy_text_component.tooltip}>
        <IconButton size="small" onClick={handleCopy} data-testid="copy-button">
          <ContentCopyIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </Box>
  );
}
